// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5921":"c68d5c95","6937":"c55765b7","8197":"c55765b7","8377":"c55765b7"}[chunkId] + ".chunk.css";
};